import { render, staticRenderFns } from "./RevokeModalTokenError.vue?vue&type=template&id=0db1c5e6"
import script from "./RevokeModalTokenError.vue?vue&type=script&lang=js"
export * from "./RevokeModalTokenError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports